/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type Heart_heartPortfolioItems$ref = any;
export type ItemHeartWrapper_item$ref = any;
export type ItemHeartWrapper_item = {
    readonly serviceId: string | null;
    readonly heartPortfolioItems?: ReadonlyArray<{
        readonly " $fragmentRefs": Heart_heartPortfolioItems$ref;
    } | null> | null;
    readonly " $refType": ItemHeartWrapper_item$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "ItemHeartWrapper_item",
    "type": "Item",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "LocalArgument",
            "name": "loadPortfolioData",
            "type": "Boolean!",
            "defaultValue": false
        },
        {
            "kind": "LocalArgument",
            "name": "userId",
            "type": "String",
            "defaultValue": ""
        }
    ],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "serviceId",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "Condition",
            "passingValue": true,
            "condition": "loadPortfolioData",
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": "heartPortfolioItems",
                    "name": "portfolioItems",
                    "storageKey": null,
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "portfolioType",
                            "value": "HEART"
                        },
                        {
                            "kind": "Variable",
                            "name": "userId",
                            "variableName": "userId"
                        }
                    ],
                    "concreteType": "PortfolioItemV2",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "Heart_heartPortfolioItems",
                            "args": null
                        }
                    ]
                }
            ]
        }
    ]
} as any);
(node as any).hash = '3cc9f9f07351654ffe5a68f9eb6b5ae3';
export default node;
